<section class="menu-card w-full">
  <article>
    <img
      loading="lazy"
      src="assets/rush/5K-gold-coins-in-pot.png"
      alt="Table illustration"
      class="h-[64x] w-[64px] self-center"
    />
    <div class="details">
      <div class="title">Coming soon</div>
      <div class="pot">
        <svg-icon [src]="'assets/rush/svg/casino-diamond.svg'"></svg-icon>
        <div class="amount">-</div>
      </div>
      <div class="normal">
        <svg-icon src="assets/svg/coins.svg" class="mr-2"></svg-icon>
        <div>-</div>
      </div>
    </div>
    <div class="closed">CLOSED</div>
  </article>
</section>
